'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (element) {
    var $this = (0, _jquery2.default)(element);
    var type = $this.attr('data-query');
    var key = $this.attr('name') || $this.attr('id');
    var value = getValue(type, $this.val());
    var dataFilterValue = $this.attr('data-filter');
    var invert = $this.attr('data-invert') === 'true';
    var queryObject = {};

    if ($this.is(':checkbox')) {
        var checkboxes = (0, _jquery2.default)('input:checkbox[name="' + key + '"]');
        if (checkboxes.length > 1 || dataFilterValue === 'array') {
            //
            var checkboxValues = checkboxes.filter(':checked').map(function () {
                return getValue(type, this.value);
            }).get();
            log('checkboxValues: %o', checkboxValues);
            queryObject[key] = checkboxValues;
        } else {
            if (invert) {
                queryObject[key] = $this.is(':checked') ? null : value;
            } else {
                queryObject[key] = $this.is(':checked') ? value : null;
            }
        }
    } else if ($this.is(':radio')) {
        queryObject[key] = $this.is(':checked') ? value : null;
    } else {
        queryObject[key] = value;
    }

    updateQuery($this, queryObject);
};

exports.updateQuery = updateQuery;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _navigator = require('./navigator');

var _navigator2 = _interopRequireDefault(_navigator);

var _querystring = require('./querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _queryFilter = require('../utils/query-filter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('debug')('linksoft:auto-query-helper');
;

function getValue(type, value) {

    switch (type) {
        case 'json':
            return JSON.parse(value);
        case 'boolean':
            return value === 'true';
        case 'string':
        default:
            return value;
    }
}

function updateQuery($element, queryObject) {
    if ($element.is('[data-filter]')) {
        var origFilter = _querystring2.default.parse(window.location.href).filter;
        queryObject = { filter: (0, _queryFilter.combine)(origFilter, queryObject), page: null };
    }
    _navigator2.default.navigate(queryObject, $element);
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/auto-query-helper.js
// module id = 415
// module chunks = 0